export default {
    formValueData:{},//临时存保存数据
    is_show_busmod_form:false,
    busmodList: [],
    busmod: '',
    dialog_auth_tips: false,
    is_agree: false,
    agreeText: '《平安银行开放银行账户服务声明》',
    auth_list: ['4001'],
    auth_list_arr: [{
        id: '4001',
        name: '余额查询',
        disabled: true
    }, {
        id: '4013',
        name: '交易明细查询'
    }, {
        id: '4047,4048',
        name: '代发交易+结果查询'
    }],
    editInfo: {}, //修改时需要传给后台
    not_select: false,
    type: 0,
    id: '',
    formButtonArr: [{
        label: '确定',
        type: 'primary',
        flag: 'add'
    }],
    is_show_form: false,
    loadingStaus: false,
    corp_type: '1',
    tabsList: [{
            label: '人资公司',
            name: '1'
        },
        {
            label: '用工企业',
            name: '2'
        },
    ],
    channelType: 'yinling',
    channelTypeList: [{
            id: 'yinling',
            name: '灵工全职'
        }, {
            id: 'xinwang',
            name: '新网银行'
        },
        {
            id: 'pingan',
            name: '平安银行'
        },
        {
            id: 'zs',
            name: '招商银行'
        },
        {
            id:'pinganpay',
            name:'平安银行（无审批）'
        }
    ],
    // 分页信息
    pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
    },
    dataList: [],
    formData: [],
    formData_zs: [ //招商银行-全职
        {
            label: '公司名称',
            type: 'select',
            field: 'corp_id',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        }, {
            label: '账户',
            type: 'input',
            field: 'acct_no',
            val: '',
            required: true
        }, {
            label: '账户名',
            type: 'input',
            field: 'acct_name',
            val: '',
            required: true
        }, {
            label: 'UID',
            type: 'input',
            field: 'merchant_no',
            val: '',
            required: true
        }, {
            label: '分行号',
            type: 'input',
            field: 'bbknbr',
            val: '',
            required: true
        }, {
            label: '用户私钥',
            type: 'input',
            field: 'private_key',
            val: '',
            required: true
        }, {
            label: '银行公钥',
            type: 'input',
            field: 'pf_public_key',
            val: '',
            required: true
        },
        {
            label: '对称秘钥',
            type: 'input',
            field: 'des_key',
            val: '',
            required: true
        }
    ],
    formData_3: [ //pingan
        {
            label: '公司名称',
            type: 'select',
            field: 'corp_id',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        }, {
            label: '账户',
            type: 'input',
            field: 'acct_no',
            val: '',
            required: true
        }, {
            label: '账户名',
            type: 'input',
            field: 'acct_name',
            val: '',
            required: true
        }, {
            label: '手机号',
            type: 'input',
            field: 'mobile',
            val: '',
            required: true
        }
    ],
    formData_2: [ //新网银行
        {
            label: '公司名称',
            type: 'select',
            field: 'corp_id',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        },
        {
            label: '商户号',
            type: 'input',
            field: 'merchant_no',
            val: '',
            required: true
        }, {
            label: '商户AppId',
            type: 'input',
            field: 'app_id',
            val: '',
            required: true
        }, {
            label: '账户',
            type: 'input',
            field: 'acct_no',
            val: '',
            required: true
        }, {
            label: '账户名',
            type: 'input',
            field: 'acct_name',
            val: '',
            required: true
        }
    ],
    formData_1: [ //灵工
        {
            label: '公司名称',
            type: 'select',
            field: 'corp_id',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        },
        {
            label: '税源地',
            type: 'select',
            field: 'uid',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        }
    ],
    formData_0: [{ //兼职
            label: '公司名称',
            type: 'select',
            field: 'corp_id',
            val: '',
            filterable: true,
            required: true,
            typeData: []
        },
        {
            label: 'UID',
            type: 'input',
            field: 'uid',
            val: '',
            required: true
        }, {
            label: 'companyld',
            type: 'input',
            field: 'company_id',
            val: '',
            required: true
        },
        {
            label: 'account',
            type: 'input',
            field: 'account',
            val: '',
            required: true
        },
        {
            label: 'mainAccount',
            type: 'input',
            field: 'channel_account',
            val: '',
            required: true
        },
        {
            label: '是否签约',
            type: 'radioGroup',
            field: 'is_sign',
            val: 1,
            required: true,
            typeData: [{
                    label: '是',
                    val: 1
                },
                {
                    label: '否',
                    val: 0
                }
            ]
        }
    ],
    formData_4: [{ //兼职
        label: '公司名称',
        type: 'select',
        field: 'corp_id',
        val: '',
        filterable: true,
        required: true,
        typeData: []
    },
    {
        label: 'UID',
        type: 'input',
        field: 'uid',
        val: '',
        required: true
    }, {
        label: 'companyld',
        type: 'input',
        field: 'company_id',
        val: '',
        required: true
    },
    {
        label: 'account',
        type: 'input',
        field: 'account',
        val: '',
        required: true
    },
    {
        label: 'mainAccount',
        type: 'input',
        field: 'channel_account',
        val: '',
        required: true
    },
    {
        label: '是否签约',
        type: 'radioGroup',
        field: 'is_sign',
        val: 0,
        disabled:true,
        required: true,
        typeData: [{
                label: '是',
                val: 1
            },
            {
                label: '否',
                val: 0
            }
        ]
    }
],
    columns: [{
            title: "公司名称",
            value: "company_name",
            header_align: "center",
            align: "center",
        },
        {
            title: "负责人手机号",
            value: "contact_phone",
            header_align: "center",
            align: "center",
        },
        {
            title: "通道名称",
            value: "channel_name",
            header_align: "center",
            align: "center",
        },
    ],
    searchCondition: {
        status: '',
        corp_name: '',
    },
    // typeList:[
    //     {id:'0',name:'待审核'},
    //     {id:'1',name:'审核通过'},
    //     {id:'2',name:'审核拒绝'}
    // ],
}
